let stub = require('./stub');

let tracking = require('./tracking');

let ls = 'localStorage' in global && global.localStorage ? global.localStorage : stub;

function isBoolean(value) {
  return typeof value === 'string' && (value === 'true' || value === 'false');
}

function getBoolean(value) {
  return value === 'true';
}

function get(key) {
  try {
    const value = ls.getItem(key);
    return isBoolean(value) ? getBoolean(value) : JSON.parse(value);
  } catch (error) {
    console.error(error);
    return null;
  }
}

function set(key, value) {
  try {
    isBoolean(value) ? s.setItem(key, getBoolean(value)) : ls.setItem(key, JSON.stringify(value));
    return true;
  } catch (e) {
    return false;
  }
}

function remove(key) {
  return ls.removeItem(key);
}

function removeByGlobalKey(key) {

  if (key === undefined || key === null || key === '') return false;
  for (var i in ls) {
    if (i.indexOf(key) === 0) {
      ls.removeItem(i);
    }
  }
  return true;
}

function clear() {
  return ls.clear();
}

function accessor(key, value) {
  if (arguments.length === 1) {
    return get(key);
  }
  return set(key, value);
}

accessor.set = set;
accessor.get = get;
accessor.remove = remove;
accessor.removeByGlobalKey = removeByGlobalKey;
accessor.clear = clear;
accessor.on = tracking.on;
accessor.off = tracking.off;

export default accessor;



// WEBPACK FOOTER //
// ./src/library/local-storage/index.js